import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';

// Mirrors SYSTEM_HEALTH_PERIOD_DAYS in the domain; the endpoint rejects anything else.
export const HEALTH_PERIOD_OPTIONS = [
  { value: 7, label: 'Last 7 days' },
  { value: 30, label: 'Last 30 days' },
  { value: 90, label: 'Last 90 days' },
] as const;

export type HealthPeriodDays = (typeof HEALTH_PERIOD_OPTIONS)[number]['value'];

export const DEFAULT_HEALTH_PERIOD: HealthPeriodDays = 90;

const SYSTEM_HEALTH_QUERY_KEY = 'systemHealth';

export function useGetSystemHealth(tenantId: string, days: HealthPeriodDays = DEFAULT_HEALTH_PERIOD) {
  const { getTenantId } = useTenants();
  const currentUserTenantId = getTenantId();

  return useQuery({
    queryKey: [SYSTEM_HEALTH_QUERY_KEY, { tenantId, days }],
    queryFn: async () => {
      const response = await api.tenants.getSystemHealth(tenantId, days);
      return response.data;
    },
    enabled: !!tenantId && !!currentUserTenantId,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
}
